/* unplugin-vue-components disabled */import script from "./WORWORelationsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./WORWORelationsCard.vue?vue&type=script&setup=true&lang=js"

import "./WORWORelationsCard.vue?vue&type=style&index=0&id=3c0e52a5&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c0e52a5"]])

export default __exports__